import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Tab from '@mui/material/Tab';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  icon: {
    color: 'white',
    opacity: 0.54,
    minWidth: 0,

    '&.Mui-selected': {
      opacity: 1,
      color: '#FE9400',
    },
  },
  hidden: {
    visibility: 'hidden',
  },
});

const IconTab = (props) => {
  const classes = useStyles();

  return (
    <Tab
      {...props}
      disableRipple
      className={clsx(classes.icon, { [classes.hidden]: props.hidden })}
    />
  );
};

IconTab.propTypes = {
  hidden: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
};

export default memo(IconTab);
